interface Props {
    confirmed: number;
    target: number;
    failed?: number;
    pending?: number;
    compact?: boolean;
}

export const ConfirmedProgress = ({confirmed, target, failed = 0, pending, compact = false}: Props) => {
    const total = target > 0 ? target : 1;
    const confirmedPct = Math.min(100, Math.round((confirmed / total) * 100));
    const failedPct = Math.min(100 - confirmedPct, Math.round((failed / total) * 100));

    return (
        <div className="w-full min-w-0">
            <div className={`flex min-w-0 justify-between gap-3 text-ink-muted mb-1 ${compact ? 'text-[11px]' : 'text-xs'}`}>
                <span>{confirmed} / {target} confirmed</span>
                {pending != null && pending > 0 && <span className="shrink-0">{pending} pending</span>}
            </div>
            <div className={`${compact ? 'h-1.5' : 'h-2'} w-full bg-surface-muted rounded overflow-hidden flex`}>
                <div className="bg-success h-full" style={{width: `${confirmedPct}%`}}/>
                <div className="bg-danger h-full" style={{width: `${failedPct}%`}}/>
            </div>
        </div>
    );
};
